import { useQuery } from "@tanstack/react-query";

import { EncryptedCertificate } from "shared/tg/types";

type Params = {
  id?: string;
};

type Response = EncryptedCertificate;

export const useBlumResultQuery = (
  params: Params
  // options?: QueryOptions<Response, unknown, TData>
) => {
  return useQuery({
    queryKey: ["blum-results", params.id],
    queryFn: async () => {
      const response = await fetch(
        `${import.meta.env.VITE_BLUM_GUARDIAN_URL}/certificate?id=${params.id}`
      );
      const str = await response.text();

      if (str.includes("not ready")) {
        throw new Error(str);
      }

      const data: Response = JSON.parse(str);

      return data;
    },
    refetchInterval: (query) => {
      if (query.state.data) return false;
      if (query.state.error?.message.includes("not ready")) return 2000;

      return false;
    },
    enabled: Boolean(params.id),
  });
};
